// extracted by mini-css-extract-plugin
export default {"Octicon_0":"FilterRevert-module__Octicon_0--kGCqF","Link_0":"FilterRevert-module__Link_0--ykkkc"};